/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UiButton } from '../../ui-button/ui-button';
import { Filterable } from '../../../mixins/Filterable';
import { Mixin } from '../../../mixins/Mixin';

@Component({
    selector: 'fe-button',
    template: require('./fe-button.html'),
    styles: [
        require('./fe-button.less')
    ],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: FeButton, multi: true}
    ],
})

@Mixin([Filterable])
export class FeButton extends UiButton {

    @Input('progress') public showProgress: boolean = false;
    @Input() boldTitle: boolean = false;
    @Output() clickAction = new EventEmitter();

    constructor(public elementRef: ElementRef) {
        super(elementRef);
    }

    /*private clicked(event) {
      this.clickAction.emit(event);
    }*/
}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/form-elements/fe-button/fe-button.ts